/* eslint-disable */
// Theses classes should correspond to the softmax output of your model.

export const MODEL_CLASSES = {
  0: 'Improper Storage of Trash (Barrels)',
  1: 'Needle Pickup',
  2: 'Parking Enforcement',
  3: 'Pick up Dead Animal',
  4: 'Poor Conditions of Property',
  5: 'Request for Pothole Repair',
  6: 'Requests for Street Cleaning',
  7: 'Sidewalk Repair (Make Safe)',
  8: 'Sign Repair',
};
